export const FETCH_UOM_REQUEST = 'FETCH_UOM_REQUEST';
export const FETCH_UOM_SUCCESS = 'FETCH_UOM_SUCCESS';
export const FETCH_UOM_FAILURE = 'FETCH_UOM_FAILURE';

export const ADD_UOM_REQUEST = 'ADD_UOM_REQUEST';
export const ADD_UOM_SUCCESS = 'ADD_UOM_SUCCESS';
export const ADD_UOM_FAILURE = 'ADD_UOM_FAILURE';

export const UPDATE_UOM_REQUEST = 'UPDATE_UOM_REQUEST';
export const UPDATE_UOM_SUCCESS = 'UPDATE_UOM_SUCCESS';
export const UPDATE_UOM_FAILURE = 'UPDATE_UOM_FAILURE';

export const DELETE_UOM_REQUEST = 'DELETE_UOM_REQUEST';
export const DELETE_UOM_SUCCESS = 'DELETE_UOM_SUCCESS';
export const DELETE_UOM_FAILURE = 'DELETE_UOM_FAILURE';

export const UOM_FORM_ERROR = 'UOM_FORM_ERROR';
export const UOM_FORM_SUCCESS = 'UOM_FORM_SUCCESS';
export const SET_UOM_EDIT = 'SET_UOM_EDIT';
export const CLEAR_UOM_EDIT = 'CLEAR_UOM_EDIT'; 